module.exports = __webpack_public_path__ + "img/marquee-boxer.61ade163.webp";